import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationsService } from '../../../_services/locations/locations.service';
import * as $ from 'jquery';
import {  } from 'googlemaps';

@Component({
  selector: 'app-add-locations',
  templateUrl: './add-locations.component.html',
  styleUrls: ['./add-locations.component.css'],
  providers: [LocationsService]
})
export class AddLocationsComponent implements OnInit {
  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  marker: google.maps.Marker;
  data:any = {};
  lat:any = {};
  lng:any = {};
  serviceprovider: any;
  countries: any;
  brands: any;

  constructor(
    private locationsService: LocationsService,
    private formBuilder: FormBuilder
  ) {

    this.locationsService.getServiceProviderType().subscribe(
      res => {
        this.serviceprovider = res;
      }
    );

    this.locationsService.getcountries().subscribe(
      res => {
        this.countries = res;
      }
    );

    this.locationsService.getbrands().subscribe(
      res => {
        this.brands = res;
        //console.log(this.brands, 9009);
      }
    );


  }
  
  ngOnInit() {
    this.setGoogleMapLocationMarkerForResidence('40.730610', '-73.935242', '', this.data);
  }

  @ViewChild('submit_location') submit_location:ElementRef;
  addLocation() {
     console.log(this.data,this.data.lat,this.data.lng, 12000);
    this.submit_location.nativeElement.disabled = true;
    this.locationsService.saveLocations(this.data).subscribe(
      res => {
        if(res.err == '0'){
            alert("Something went wrong please contact admin");
        }else{
            window.location.reload();
        }

      }
    );
  } 
  
	white_space(modelval: any,id: any)
	{
		console.log(modelval,id);
		if(modelval.length > 0 && modelval == ' '){
			id.name = '';
		}
		
		//if($("#"+id).val() == " "){
	//				modelval = '';
	//	}
	}

  setGoogleMapLocationMarkerForResidence(latitude, longitude, residenceName, data) {
    if(latitude != ''
      && latitude != null
      && !isNaN(latitude)
      && longitude != ''
      && longitude != null
      && !isNaN(longitude)) {

      var mapProp = {
        center: new google.maps.LatLng(latitude, longitude),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);

      this.marker = new google.maps.Marker({
        position: new google.maps.LatLng(latitude, longitude),
        map: this.map,
        draggable: true,
        title: residenceName
      });

       // adds a listener to the marker
            // gets the coords when drag event ends
            // then updates the input with the new coords
            google.maps.event.addListener(this.marker, 'dragend', function (evt) {
              // $("#txtLat").val(evt.latLng.lat().toFixed(6));
              // $("#txtLng").val(evt.latLng.lng().toFixed(6));
              this.map.panTo(evt.latLng);
              console.log(evt.latLng.lat().toFixed(6));
              console.log(evt.latLng.lng().toFixed(6));
           
              data.lat = evt.latLng.lat().toFixed(6);
              data.lng = evt.latLng.lng().toFixed(6);
          });
          // centers the map on markers coords
          //this.map.setCenter(this.marker.position);
          // adds the marker on the map
          this.marker.setMap(this.map);

    } else {
      //Display General Map If Latitude & Longitude is not set
      var mapProp = {
        center: new google.maps.LatLng(40.7128, -73.935242),
        zoom: 4,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    }

     

  }

  setMapType(mapTypeId: string) {
    this.map.setMapTypeId(mapTypeId);
  }


}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/locations/add-locations/add-locations.component.ts